var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
import { Checkbox, Flex } from "./..";
import { DataTableTrigger } from './';
import { Cell } from './Cell';
import { TableBodyRow, TableExpansion, TableCell } from './DataTableComponents';
var Row = /** @class */ (function (_super) {
    __extends(Row, _super);
    function Row() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.state = {
            isExpanded: typeof _this.props.isExpanded !== 'undefined'
                ? !!_this.props.isExpanded
                : !!_this.props.defaultIsExpanded
        };
        _this.onExpandRow = function () {
            if (typeof _this.props.isExpanded !== 'undefined' &&
                typeof _this.props.onExpandRow === 'function') {
                _this.props.onExpandRow(_this.props.item[_this.props.keySelector]);
            }
            else {
                _this.setState({ isExpanded: !_this.state.isExpanded });
            }
        };
        _this.onSelectRow = function () {
            if (typeof _this.props.onSelectRow === 'function') {
                _this.props.onSelectRow(_this.props.item[_this.props.keySelector]);
            }
        };
        _this.hasRowCheckbox = function () {
            if (typeof _this.props.hasRowCheckbox === 'function') {
                return _this.props.hasRowCheckbox(_this.props.item);
            }
            return true;
        };
        return _this;
    }
    Row.prototype.render = function () {
        var _this = this;
        var _a = this.props, columnsCount = _a.columnsCount, expansionRenderer = _a.expansionRenderer, expandedRowLss = _a.expandedRowLss, rowColLss = _a.rowColLss, isSelected = _a.isSelected, item = _a.item, itemIndex = _a.itemIndex, onExpandRow = _a.onExpandRow, onSelectRow = _a.onSelectRow, hasRowCheckbox = _a.hasRowCheckbox, wrapExpandedContent = _a.wrapExpandedContent, lss = _a.lss, columns = _a.columns, isClickableRow = _a.isClickableRow, index = _a.index;
        var isExpanded = typeof this.props.isExpanded !== 'undefined'
            ? !!this.props.isExpanded
            : !!this.state.isExpanded;
        var hasCheckbox = function () {
            if (typeof hasRowCheckbox === 'function') {
                return hasRowCheckbox(item);
            }
            return typeof onSelectRow === 'function';
        };
        var content = (React.createElement(TableBodyRow, { lss: lss },
            (onSelectRow || onExpandRow) && (React.createElement(TableCell, null,
                React.createElement(Flex, null,
                    hasCheckbox() && (React.createElement(Checkbox, { "aria-label": isSelected ? 'Deselect row' : 'Select row', checked: isSelected, lss: { mr: 'sm' }, name: "", onChange: this.onSelectRow })),
                    expansionRenderer && (React.createElement(DataTableTrigger, { isExpanded: isExpanded, isStatic: true, onClick: this.onExpandRow }))))),
            columns.map(function (column, cIndex) { return (React.createElement(Cell, __assign({}, column, { lss: rowColLss, key: cIndex, item: item, isClickableRow: isClickableRow, onClick: function () { return isClickableRow && _this.onExpandRow(); }, index: index }))); })));
        if (!expansionRenderer) {
            return content;
        }
        if (wrapExpandedContent === false) {
            return (React.createElement(React.Fragment, null,
                content,
                expansionRenderer &&
                    isExpanded &&
                    expansionRenderer(item, itemIndex)));
        }
        return (React.createElement(React.Fragment, null,
            content,
            expansionRenderer && isExpanded && (React.createElement(TableExpansion, null,
                (onSelectRow || onExpandRow) && React.createElement(TableCell, { lss: expandedRowLss }),
                React.createElement(TableCell, { colSpan: columnsCount, lss: expandedRowLss }, expansionRenderer(item, itemIndex))))));
    };
    return Row;
}(React.Component));
export { Row };
//# sourceMappingURL=Row.js.map